// extracted by mini-css-extract-plugin
export var cardIcon = "_a4-4";
export var checkboxCard = "_a4-0";
export var checkboxCardSelected = "_a4-1";
export var disabled = "_a4-2";
export var outerBorder = "_a4-3";
export var spacerMedium = "_a4-7";
export var spacerSmall = "_a4-6";
export var spacerXsmall = "_a4-5";